const MEKI_PATHS = new Set([
    '/meki',
    '/mi-mekisek',
    '/miert-jo-a-meki-diakmunka',
    '/munkakor',
    '/jo-tudni-meki',
]);

const INTERNSHIP_PATHS = new Set([
    '/gyakornok',
    '/jo-tudni-gyakornok',
]);

export function resolveSubsiteMenuPath(menuPath, pathname) {
    if (menuPath !== '/jo-tudni') return menuPath;

    const normalizedPath = pathname.length > 1
        ? pathname.replace(/\/+$/, '')
        : pathname;

    if (MEKI_PATHS.has(normalizedPath)) return '/jo-tudni-meki';
    if (INTERNSHIP_PATHS.has(normalizedPath)) return '/jo-tudni-gyakornok';

    return menuPath;
}
